export default {
	status_ready: 'Ready',
	status_seen: 'In progress',
	status_unseen: 'Unviewed',
};
